"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var React = __importStar(require("react"));
var App_1 = require("../../App");
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
var MfaOptions = function (_a) {
    var channel = _a.channel, sendCode = _a.sendCode, text = _a.text, track = _a.track;
    var state = React.useContext(App_1.RiskContext).state;
    var setChannel = React.useContext(VerifyAccountContext_1["default"]).setChannel;
    return (React.createElement("div", null,
        React.createElement(component_button_1["default"], { isInline: true, onClick: function () {
                track(state.workflow);
                sendCode(channel, true);
                if (typeof setChannel === 'function') {
                    setChannel(channel);
                }
            }, padding: component_button_1["default"].Padding.Default, size: component_button_1["default"].Sizes.Small, type: component_button_1["default"].Types.Link }, text)));
};
exports["default"] = MfaOptions;
